import React from "react";
import "react-multi-carousel/lib/styles.css";

import HomeNavbar from "project-components/navbars/HomeNavbar";
import HeaderPage from "project-components/headers/HeaderPage";
import Footer5 from "project-components/footers/Footer5";
import CookiePolicy from "t4/components/template/CookiePolicy";

class Page extends React.Component
{

  render() {
    return (
        <>
          <HomeNavbar />
          <HeaderPage pageTitle={this.props.title} pageSubtitle={this.props.subtitle} />
          <div className="wrapper">
            {this.props.content}
          </div>
          <Footer5 />
          <CookiePolicy />
        </>
    );
  }
}

export default Page;
